// Auto-open external links in new tabs
document.addEventListener('DOMContentLoaded', function() {
  // Find all links on the page and make external ones open in new tab
  const links = document.querySelectorAll('a[href]');
  
  links.forEach(function(link) {
    const href = link.getAttribute('href');
    
    // Check if it's an external link (not starting with /, #, mailto:, tel:)
    if (href && 
        !href.startsWith('/') && 
        !href.startsWith('#') && 
        !href.startsWith('mailto:') && 
        !href.startsWith('tel:') &&
        !href.includes(window.location.hostname)) {
      
      // Add target="_blank" and rel="noopener" for security
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    }
  });
});